/*
 * Copyright (c) 2022-2026 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */
import { z } from 'zod'

export const Location = z.object({ city: z.string(), country: z.string(), region: z.string() })

export interface Location extends z.TypeOf<typeof Location> {}
